import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";

const ContentHeader: FCX = ({
    children,
    className,
    style,
    testId,
    ...rest
}) => {
    return (
        <div
            className={
                cn(
                    "ContentHeader",
                    className,
                )
            }
            data-testid={testId}
            {...rest}
        >
            {children}
        </div>
    );
};

export default ContentHeader;